import 'css-chunksrc/client/scenes/projectMaterialResourceAddition/materialResourceForm/styles.scss';export default {
  "materialResourceForm": "_materialResourceForm_10lap_1",
  "row": "_row_10lap_8",
  "group": "_group_10lap_19",
  "label": "_label_10lap_23",
  "input": "_input_10lap_29",
  "textArea": "_textArea_10lap_45"
};